module.exports = __webpack_public_path__ + "img/alarm.7b00472d.png";